import { render, staticRenderFns } from "./GridDocumentoDiarioAcuerdo.vue?vue&type=template&id=1480d638&"
import script from "./GridDocumentoDiarioAcuerdo.vue?vue&type=script&lang=js&"
export * from "./GridDocumentoDiarioAcuerdo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports